import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

export interface StartedBatch {
  batchId: number;
  galleryId: number;
}

export interface CompletedBatch {
  batchId: number;
  galleryId: number;
  succeeded: number;
  totalJobs: number;
  failed: number;
}

export interface CompleteBatchPayload {
  galleryId: number;
  succeeded: number;
  totalJobs: number;
  failed: number;
}

export const useConstellationGenerationStore = defineStore('constellation-generation', () => {
  const activeBatches = reactive(new Map<number, { galleryId: number }>());
  const lastStartedBatch = ref<StartedBatch | null>(null);
  const lastCompletedBatch = ref<CompletedBatch | null>(null);

  function startBatch(batchId: number, galleryId: number) {
    activeBatches.set(batchId, { galleryId });
    lastStartedBatch.value = { batchId, galleryId };
  }

  function completeBatch(batchId: number, payload: CompleteBatchPayload) {
    const { galleryId, succeeded, totalJobs, failed } = payload;
    activeBatches.delete(batchId);
    lastCompletedBatch.value = { batchId, galleryId, succeeded, totalJobs, failed };
  }

  return {
    activeBatches,
    lastStartedBatch,
    lastCompletedBatch,
    startBatch,
    completeBatch,
  };
});
